<template>
    <div class="editAnnualPlan">
        <div class="wx_title"><span>XXXX巡园任务</span></div>
        <table class="my_table">
            <thead>
            <tr>
                <th width="170">执行任务时间:</th>
                <th width="210" class="th_background time">
                    <el-date-picker
                            class="fl"
                            v-model="info.display_run_time"
                            v-if="timeEdit"
                            type="date"
                            size="mini"
                            format="yyyy.MM.dd"
                            value-format="yyyy-MM-dd"
                            @change='changeRunTime'
                            placeholder="选择日期">
                    </el-date-picker>
                    <span class="time_val fl" v-else>{{info.display_run_time}}</span>
                    <span class="tab_btn fl" @click="timeEdit=true" style="display: none;">重新编辑</span>
                </th>
                <th width="170">任务执行分区:</th>
                <th width="100" class="th_background">{{info.area.name}}</th>
                <th width="170">任务作物大类:</th>
                <th class="th_background">{{info.crop_name}}</th>
                <th width="140">任务类别:</th>
                <th width="130" class="th_background">{{info.type_name}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td colspan="2">执行操作说明</td>
                <td colspan="5">
                    <el-input v-if="textareaShow" type="textarea" :autosize="{ minRows: 4}" v-model="explain"></el-input>
                    <span v-else>{{info.task_remark}}</span>
                </td>
                <td class="tab_btns" >
                    <el-button class="edit_btn" type="primary" plain size="small" @click="textareaShow = true" style="display: none;">编辑</el-button>
                    <el-button class="detail_btn" type="success" plain size="small" @click="saveRemark" style="display: none;">保存</el-button>
                    <el-button class="del_btn" type="danger" plain size="small" @click="textareaShow = false" style="display: none;">取消</el-button>
                </td>
            </tr>
            <tr>
                <td colspan="2" class="tdBack1">任务操作文档</td>
                <td colspan="6" class="tdBack2"><span v-for="(item,index) in info.task_files"  style="cursor: pointer;">
				<el-link :href="item" target="_blank" type="primary" v-if="typeof item=='string'">文件{{index+1}}</el-link>
				<el-link :href="item.file_url" target="_blank" type="primary" v-else>文件{{index+1}}</el-link>
				</span></td>
            </tr>
			<tr>
			    <td colspan="2" class="tdBack1">任务操作视频</td>
			    <td colspan="6" class="tdBack2"><span v-for="(item,index) in info.task_videos"  style="cursor: pointer;">
				<el-link :href="item" target="_blank" type="primary" v-if="typeof item=='string'">视频{{index+1}}</el-link>
				<el-link :href="item.video_url" target="_blank" type="primary" v-else>视频{{index+1}}</el-link>
				</span></td>
			</tr>
            <tr v-if="info.type_id!=5 && info.type_id!=4">
                <td rowspan="4" colspan="2">任务内容dadawaw</td>
                <td colspan="6" v-if="info.type_id==1 && info.task.task_option.indexOf('1')>=0">观察物候期</td>
            </tr>
			
			
		<tr v-if="info.type_id==3" v-for="item in info.option">
		    <td colspan="6" >关注({{item.name}})的稀释比例</td>
		</tr>
		<tr v-if="info.type_id==6 && info.task.collect_type==1" v-for="item in info.option">
		    <td colspan="6" >关注基本参数({{item.base.name}})</td>
		</tr>
		<tr v-if="info.type_id==6 && info.task.collect_type==2" v-for="item in info.option">
		    <td colspan="6" >关注病虫害({{item.option.insect_pest_name}})</td>
		</tr>
            <tr v-if="info.type_id==1 && info.task.task_option.indexOf('2')>=0">
                <td colspan="6">观察植株部位情况：
				   <span v-if="info.option.part.indexOf('1')>=0">根、</span>
				   <span v-if="info.option.part.indexOf('2')>=0">茎、</span>
				   <span v-if="info.option.part.indexOf('3')>=0">叶、</span>
				   <span v-if="info.option.part.indexOf('4')>=0">花、</span>
				   <span v-if="info.option.part.indexOf('5')>=0">果</span>
				   </td>
            </tr>
            <tr v-if="info.type_id==1 && info.task.task_option.indexOf('3')>=0">
                <td colspan="6">观察病虫害情况</td>
            </tr>
            <tr v-if="info.type_id==1 && info.task.task_option.indexOf('4')>=0">
                <td colspan="6">观察土壤湿度</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
		import {getYearTaskInfo,changeYearTaskByfield} from '@/api/api'
    export default {
        name: "editAnnualPlan",
        data(){
            return{
				task_id:'',
                 info:{
					 area:[],
					 task:[],
					 option:[],
					},
				 explain:'',
				 timeEdit:false,
                textareaShow:false,
                
            }
        },
		mounted() {
			this.task_id=this.$route.params.task_id
			this.get_year_task()
		},
        methods:{
			get_year_task(){
				getYearTaskInfo(this.task_id).then(resp=>{
					 this.info=resp
					
				})
			},
            // 重新选择时间
            changeRunTime(val){
				changeYearTaskByfield(this.task_id,{field:"display_run_time",value:val}).then(resp=>{
					this.timeEdit = false
				})
                
            },
            // 保存
            saveRemark(){
				
				changeYearTaskByfield(this.task_id,{field:"task_remark",value:this.explain}).then(resp=>{
					this.textareaShow = false
					this.$nextTick(()=>{
					    this.$router.push({ name: 'annualPlan' });
					})
				})              
                
                
            },
        }
    }
</script>

<style scoped lang="less">
    .editAnnualPlan{
        .my_table{
            margin-top: 35px;
            .th_background{
                background-color: rgba(45, 153, 255, 0.3261);
            }
            .el-textarea__inner{
                text-align: left;
            }
            .tdBack1{
                background-color: rgba(246, 137, 255, 0.46);
            }
            .tdBack2{
                background-color: rgba(246, 137, 255, 0.18);
            }
            .time{
                .time_val{
                    padding-left: 18px;
                }
                .tab_btn{
                    font-size: 16px;
                    font-weight: 500;
                    color: #2D99FF;
                    cursor: pointer;
                    padding-left: 10px;
                }
            }
            .tab_btns{
                .el-button{
                    &+.el-button{
                        margin-left: 0;
                        margin-top: 15px;
                    }
                }
            }
        }
    }
</style>